import { fetcher, FetchError, useQuery } from '@oaknorth/util-rest';
import { useAccessToken } from '@oaknorth/util-user';

const PATH = '/api/polaris/api/foundations/launch-darkly/configuration';

type FeatureFlagsConfiguration = {
  launchDarklyClientSideId: string;
  contextHash: string;
};

export function useLaunchDarklyConfig() {
  const accessToken = useAccessToken();

  const config = useQuery<FeatureFlagsConfiguration, FetchError>({
    queryKey: [PATH],
    queryFn: () =>
      fetcher<FeatureFlagsConfiguration>({
        url: PATH,
        headers: accessToken
          ? {
              // eslint-disable-next-line @oaknorth/ui/no-template-literals -- part of http request, not user facing
              authorization: `Bearer ${accessToken}`,
            }
          : undefined,
      }),
  });

  return config;
}
